module.exports = __webpack_public_path__ + "static/media/order_received_by_airline.93048adf.png";